// extracted by mini-css-extract-plugin
export var addButton = "_o1-0";
export var border = "_o1-8";
export var check = "_o1-h";
export var danger = "_o1-6";
export var dropdownContainer = "_o1-1";
export var editModalBody = "_o1-j";
export var footerContainer = "_o1-i";
export var fullWidth = "_o1-a";
export var hide = "_o1-9";
export var icon = "_o1-3";
export var input = "_o1-7";
export var inputFlex = "_o1-b";
export var inputWrapper = "_o1-c";
export var manualFocus = "_o1-5";
export var optionButton = "_o1-4";
export var pillWrapper = "_o1-e";
export var pointer = "_o1-2";
export var showOverflow = "_o1-f";
export var tagsFlex = "_o1-d";
export var xButton = "_o1-g";